type Translator = (key: string) => string;

const SYSTEM_REOPENED_AFTER_MESSAGE = "Ticket reopened after new message.";
const SYSTEM_REOPENED_BY_ADMIN = "Ticket reopened by admin.";
const SYSTEM_CLOSED_BY_REPORTER = "Ticket closed by reporter.";
const SYSTEM_CLOSED_BY_ADMIN = "Ticket closed by admin.";
const SYSTEM_CLOSED_BY_ADMIN_LEGACY = "Ticket closed by administrator.";

const ATTACHMENT_REMOVED_BY_ADMIN_PATTERN =
  /^Attachment removed by admin \((.+)\): (.+)$/;

const replaceTemplate = (
  template: string,
  values: Record<string, string>
): string => {
  let output = template;
  Object.entries(values).forEach(([key, value]) => {
    output = output.replace(new RegExp(`{{\\s*${key}\\s*}}`, "g"), value);
  });
  return output;
};

export const localizeTicketMessageText = (
  rawText: string | null | undefined,
  t: Translator
): string => {
  if (!rawText) return "";
  const text = rawText.trim();
  if (!text) return "";

  if (text === SYSTEM_REOPENED_AFTER_MESSAGE) {
    return t("account.ticketSystemReopenedAfterMessage");
  }
  if (text === SYSTEM_REOPENED_BY_ADMIN) {
    return t("account.ticketSystemReopenedByAdmin");
  }
  if (text === SYSTEM_CLOSED_BY_REPORTER) {
    return t("account.ticketSystemClosedByReporter");
  }
  if (text === SYSTEM_CLOSED_BY_ADMIN || text === SYSTEM_CLOSED_BY_ADMIN_LEGACY) {
    return t("account.ticketSystemClosedByAdministrator");
  }

  const attachmentRemovedMatch = text.match(ATTACHMENT_REMOVED_BY_ADMIN_PATTERN);
  if (attachmentRemovedMatch) {
    return replaceTemplate(
      t("account.ticketSystemAttachmentRemovedByAdmin"),
      {
        admin: attachmentRemovedMatch[1],
        filename: attachmentRemovedMatch[2],
      }
    );
  }

  return rawText;
};
